import type { CareerBenefits } from "../CareerBenefits.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const benefitsNameMap: Record<keyof CareerBenefits, LocalizedString> = {
	finances: { [Locale.cs]: "Finanční a mzdové benefity", [Locale.en]: "Financial and salary benefits" },
	timeFlexibility: { [Locale.cs]: "Časová flexibilita", [Locale.en]: "Time flexibility" },
	personalDevelopment: { [Locale.cs]: "Vzdělávání a osobní rozvoj", [Locale.en]: "Education and personal development" },
	meals: { [Locale.cs]: "Stravování", [Locale.en]: "Catering" },
	health: { [Locale.cs]: "Zdraví a wellness", [Locale.en]: "Health and wellness" },
	technologies: { [Locale.cs]: "Komunikace, technologie", [Locale.en]: "Communication, Technology" },
	transport: { [Locale.cs]: "Doprava, parkování", [Locale.en]: "Transportation, parking" },
	companyCulture: { [Locale.cs]: "Firemní kultura a akce", [Locale.en]: "Corporate culture and events" },
	workEnvironment: { [Locale.cs]: "Pracovní prostředí", [Locale.en]: "Work environment" },
	additional: { [Locale.cs]: "Další benefity", [Locale.en]: "Other benefits" },
};
